import React from "react";
import VerticalPage from "@/verticals/VerticalPage";
import { bienEtreData } from "@/verticals/verticalData";

export default function BienEtrePage() {
  return <VerticalPage data={bienEtreData} />;
}
